<style>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="carrier_name" class="label"> {{ $t("carrier_name") }} </label>
                                <app-input
                                    type="text"
                                    :placeholder="$t('carrier_name')"
                                    v-model="inputs.carrier_name"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="booking" class="label"> {{ $t("booking") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('booking')"
                                    v-model="inputs.booking"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="master_bl" class="label"> {{ $t("master_bl") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('master_bl')"
                                    v-model="inputs.masterBl"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="house_bl" class="label"> {{ $t("house_bl") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('house_bl')"
                                    v-model="inputs.houseBl"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="container" class="label"> {{ $t("container") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('container')"
                                    v-model="inputs.container"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="seal" class="label"> {{ $t("seal") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('seal')"
                                    v-model="inputs.seal"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="vessel" class="label"> {{ $t("vessel") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('vessel')"
                                    v-model="inputs.vessel"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="voyage" class="label"> {{ $t("voyage") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('voyage')"
                                    v-model="inputs.voyage"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="port" class="label"> {{ $t("port") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('port')"
                                    v-model="inputs.port"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="etd" class="label"> {{ $t("etd") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('etd')"
                                    v-model="inputs.etd"
                                    :disabled="disabled || isDisabled" 
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="eta" class="label"> {{ $t("eta") }}</label>
                                <app-input 
                                    type="date" 
                                    :placeholder="$t('eta')"
                                    v-model="inputs.eta"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="terminal" class="label"> {{ $t("terminal") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('terminal')"
                                    v-model="inputs.terminal"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="lfd" class="label"> {{ $t("lfd") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('lfdf')"
                                    v-model="inputs.lfd"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="custom_broker" class="label"> {{ $t("custom_broker") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('custom_broker')"
                                    v-model="inputs.custom_broker"
                                    :disabled="disabled || isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="trucker" class="label"> {{ $t("trucker") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('trucker')"
                                    v-model="inputs.trucker"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="trucking_rate" class="label"> {{ $t("trucking_rate") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('trucking_rate')"
                                    v-model="inputs.trucking_rate"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="ocean_fr_rate" class="label"> {{ $t("ocean_fr_rate") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('ocean_fr_rate')"
                                    v-model="inputs.ocean_fr_rate"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="pars" class="label"> {{ $t("pars") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('pars')"
                                    v-model="inputs.pars"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="paps" class="label"> {{ $t("paps") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('paps')"
                                    v-model="inputs.paps"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="pu_number" class="label"> {{ $t("pu_number") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('pu_number')"
                                    v-model="inputs.pu_number"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="returned_empty" class="label"> {{ $t("returned_empty") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('returned_empty')"
                                    v-model="inputs.returned_empty"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="special_conditions" class="label"> {{ $t("special_conditions") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('special_conditions')"
                                    v-model="inputs.special_conditions"
                                    :disabled="isDisabled"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="status" class="label"> {{ $t("status") }}</label>
                                <app-input
                                    type="search-select"
                                    v-model="inputs.status"
                                    :placeholder="'Select status'"
                                    :list="[
                                        {id:1, value: 'Pending'},
                                        {id:2, value: 'Booking'},
                                    ]"
                                    :disabled="isDisabled"
                                />
                               
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="save"
                            :disabled="isDisabled"
                        >
                            {{ $t('save') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin],
    data() {
        return {
            disabled : false,
            isDisabled : true,
            inputs: {
                carrier_name : null,
                booking : null,
                masterBl : null,
                houseBl : null,
                container : null,
                seal : null,
                vessel : null,
                voyage : null,
                port : null,
                etd : null,
                eta : null,
                lfd : null,
                custom_broker : null,
                trucker : null,
                trucking_rate : null,
                ocean_fr_rate : null,
                pars : null,
                paps : null,
                pu_number : null,
                returned_empty : null,
                special_conditions : null,
                status : null,
            },
            preloader : false,
        }  
    },
    methods: {
       async save(){
            this.preloader = true;
            try {
                const { data } = await axios.post(
                    `/api/subcontract/save_shipping/${this.contractId}`,
                    this.inputs
                );
                this.$toastr.s(data.message || this.$t('saved_successfully'));
                if (this.inputs['status'] > 1) {
                    this.disabled = true;
                }else{
                    this.disabled = false;
                }
            } catch (e) {
                const errors = e.response?.data?.errors;
                const msg = errors
                    ? Object.values(errors)[0][0]
                    : (e.response?.data?.message || this.$t('something_went_wrong'));
                this.$toastr.e(msg);
            } finally {
                this.preloader = false;
            }
        },

        async loadData() {
            try {
                this.preloader = true;
                const { data } = await axios.get(
                    `/api/subcontract/get_shipping/${this.contractId}`
                );
                if (data) {
                    const {subcontract} = data; 
                    const {logistic_status : status} = subcontract;

                    if (status) {
                        this.inputs['status'] = status ?? null;
                        if (status > 1) {
                            this.disabled = true;
                        }
                    }
                    Object.keys(this.inputs).forEach(key => {
                        if (key == 'status') return;
                        this.inputs[key] = data[key] ?? null;
                    });
                }
                this.preloader = false;
            } catch (e) {
                console.log(`errro ${e}`);
                this.preloader = false;
            }
        },
    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){

            }
        }
    },

    props: {
        props: { type: Object, default: () => ({}) }
    },

    mounted() { 
        this.contractId = this.props?.id ?? this.$route?.params?.id ?? null;
        if (!this.contractId) {
            console.warn('subcontract id not found', this.props, this.$route?.params);
            return;
        }
        this.loadData(); 
        let isLogisticCoordinator = false;
        const roles = user.roles;
        roles.forEach( rol => {
            if (rol.name === 'Logistics Coordinator') {
                isLogisticCoordinator = true;
            }
        });
        if (isLogisticCoordinator) {
            this.isDisabled = false;
        }  
    },
}
</script>
